import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { useLayout } from "../Contexts/LayoutContext";

const SkipToMainContent = () => {
  const { dataRef: ref } = useLayout();

  const location = useLocation();
  const focusResetRef = useRef(null);

  const handleClick = (e) => {
    e.preventDefault();

    if (!ref.current) return;

    const heading = document.getElementById("main-heading");

    if (heading) {
      heading.focus();
    } else {
      ref.current.focus();
    }

    // // Find ALL focusable elements inside the page
    // const focusable = ref.current.querySelectorAll("h1"
    //   // `button:not([disabled]),
    //   //      [href],
    //   //      input:not([disabled]),
    //   //      select:not([disabled]),
    //   //      textarea:not([disabled]),
    //   //      [tabindex]:not([tabindex="-1"])`
    // );

    // for (let el of focusable) {
    //   // Skip elements inside header
    //   if (
    //     !el.closest("header, [role='banner']") &&
    //     !el.classList.contains("skip-link") // skip itself
    //   ) {
    //     el.focus();

    //     return;
    //   }
    // }

    // fallback → focus wrapper
    // ref.current.focus();
  };

  useEffect(() => {
    // small delay ensures DOM is ready
    setTimeout(() => {
      focusResetRef.current?.focus();
    }, 0);
  }, [location.pathname]);

  return (
    <div>
      <div ref={focusResetRef} tabIndex="-1" className="focus-reset" />
      <a href="#main-content" onClick={handleClick} className="skip-link">
        Skip to main content
      </a>
    </div>
  );
};

export default SkipToMainContent;
